import { PrimaryButton } from '@designsforhealth/dfh-react-components'
import { CircularProgress } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

export interface LoadMoreProps {
  className?: string
  buttonText: string
  loading: boolean
  onLoadMore: () => Promise<unknown>
}

const LoadMore: React.VFC<LoadMoreProps> = ({ className, buttonText, onLoadMore, loading }) => {
  return (
    <div className={className}>
      <PrimaryButton disabled={loading} onClick={onLoadMore}>
        {loading ? <CircularProgress size={24} color="inherit" /> : buttonText}
      </PrimaryButton>
    </div>
  )
}

const StyledLoadMore = styled(LoadMore)({
  marginBottom: '30px',
  marginTop: '30px',
  textAlign: 'center',
})

export default StyledLoadMore
